<template>
  <ColumnWithHelp
    :min-width="130"
    sortable
    :resizable="false"
    :title="$t('ADVERTISEMENT.BID.COLUMN_DESC_CONV_RATE_TITLE')"
    :content="$t('ADVERTISEMENT.BID.COLUMN_DESC_CONV_RATE_CONTENT')"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template slot-scope="{ row: { conversionRate } }">
      %{{ priceFormat(conversionRate) }}
    </template>
  </ColumnWithHelp>
</template>

<script>
import { format as priceFormat } from '@/utils/number';

import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';

export default {
  name: 'ConversionRateColumn',
  components: {
    ColumnWithHelp,
  },
  inheritAttrs: false,
  methods: {
    priceFormat,
  },
};
</script>
